import { giphyDarkGrey } from '@giphy/js-brand'
import { Button } from '@giphy/react-giphy-brand'
import React, { useContext, useState } from 'react'
import { IChannel } from 'shared/types/channel'
import styled, { ThemeProvider } from 'styled-components'
import { Section } from '.'
import { CollectionContext, fakeRootChannelId } from '..'
import AddToButton from './add-to-button'
import Breadcrumbs, { singleColumnNumberOfCrumbs } from './breadcumbs'
import ChannelList from './channel-list'
import CollectionDnD from './collection-dnd'
import { AddToCollectionContext } from './context'
import EmptyCollectionCTA from './empty-collection-cta'

const Container = styled.div`
    width: 100%;
    background: ${giphyDarkGrey};
`

const Nav = styled.div`
    display: flex;
    flex-direction: column;
`

const AddToButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 12px 27px;

    ${Button} {
        width: 100%;
    }
`

type Props = {
    onAdd: (channelId: number, searchChannelId: number) => void
}

const ChildrenChannel = styled.div``
const empty = {} as IChannel
export const SingleColumn = ({ onAdd }: Props) => {
    const { channels, rootChannelId } = useContext(CollectionContext)
    const rootChannel = channels[rootChannelId]
    const hasChildren = rootChannel.children?.length > 0
    const [isReordering, setReordering] = useState(false)
    const [activeChannelId, setActiveChannelId] = useState<number>(rootChannelId)
    const findChannel = (id: number) => channels[id] || empty
    const selectedChannel = findChannel(activeChannelId)
    const value = {
        activeChannelId,
        setActiveChannelId,
        isReordering,
    }
    const showBreadcrumbs = !!(selectedChannel && channels[selectedChannel.parent])
    return (
        <ThemeProvider theme={{ isSingleColumn: true }}>
            <AddToCollectionContext.Provider value={value}>
                <Container>
                    {hasChildren ? (
                        <Nav>
                            <CollectionDnD setReordering={setReordering}>
                                {showBreadcrumbs && (
                                    <Breadcrumbs
                                        showRoot
                                        channel={selectedChannel}
                                        numberOfCrumbs={singleColumnNumberOfCrumbs}
                                        maxCrumbLength={13}
                                    />
                                )}
                                <ChildrenChannel>
                                    <Section>
                                        <ChannelList channel={selectedChannel} key={selectedChannel.id} />
                                    </Section>
                                </ChildrenChannel>
                            </CollectionDnD>
                            <AddToButtonContainer>
                                {activeChannelId !== fakeRootChannelId && (
                                    <AddToButton
                                        displayName={selectedChannel.display_name}
                                        onClick={() => onAdd(activeChannelId, rootChannelId)}
                                    />
                                )}
                            </AddToButtonContainer>
                        </Nav>
                    ) : (
                        <EmptyCollectionCTA channel={selectedChannel} />
                    )}
                </Container>
            </AddToCollectionContext.Provider>
        </ThemeProvider>
    )
}

export default SingleColumn
